import React from "react";
import { cn } from "../../utils/lib";

export function OrdersIcon({ className, ...props }) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      className={cn("w-full h-auto", className)}
      {...props}
    >
      <path
        d="M16.6668 6.87435V14.9993C16.6668 17.4993 15.1752 18.3327 13.3335 18.3327H6.66683C4.82516 18.3327 3.3335 17.4993 3.3335 14.9993V6.87435C3.3335 4.16602 4.82516 3.54102 6.66683 3.54102C6.66683 4.05768 6.87514 4.52435 7.21681 4.86601C7.55847 5.20768 8.02516 5.41602 8.54183 5.41602H11.4585C12.4918 5.41602 13.3335 4.57435 13.3335 3.54102C15.1752 3.54102 16.6668 4.16602 16.6668 6.87435Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.3332 3.54102C13.3332 4.57435 12.4915 5.41602 11.4582 5.41602H8.5415C8.02484 5.41602 7.55815 5.20768 7.21648 4.86601C6.87481 4.52435 6.6665 4.05768 6.6665 3.54102C6.6665 2.50768 7.50817 1.66602 8.5415 1.66602H11.4582C11.9748 1.66602 12.4415 1.87435 12.7832 2.21602C13.1249 2.55769 13.3332 3.02435 13.3332 3.54102Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.6665 10.834H9.99984"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.6665 14.166H13.3332"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
